import { createCrudApi } from './crud';

export interface Technician {
  id: number;
  technicianCode: string;
  technicianName: string;
  mobile: string | null;
  aadhaar: string | null;
  panNumber: string | null;
  stateId: number | null;
  skillCategory: string | null;
  experienceYears: number | null;
  status: 'active' | 'inactive';
  createdAt: string;
}

export interface CreateTechnicianInput {
  technicianName: string;
  mobile?: string;
  aadhaar?: string;
  panNumber?: string;
  stateId?: number | null;
  skillCategory?: string;
  experienceYears?: number | null;
  status?: 'active' | 'inactive';
}

export const techniciansApi = createCrudApi<Technician, CreateTechnicianInput>('technicians');
